import * as React from "react";
import { Button, ButtonProps } from "@mui/material";
export default function MajorButton(props: ButtonProps) {
  const defaultProps: ButtonProps = Object.assign(
    { type: "submit", variant: "contained", color: "primary", fullWidth: true },
    props
  );

  return (
    <Button
      {...defaultProps}
      // type="submit"
      // variant="contained"
      // color="primary"
    >
      {props.children}
    </Button>
  );
}
